var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mf-tooltip',{attrs:{"top":"","variant":"secondary"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('div',_vm._g({staticClass:"status-chip"},on),[_c('v-icon',{attrs:{"small":"","color":"vermelho-0"}},[_vm._v(" warning ")]),_c('span',[_vm._v(_vm._s(_vm.text))])],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.tooltip))])])}
var staticRenderFns = []

export { render, staticRenderFns }